import React, { useEffect } from 'react';
import { MarkdownLite, Text, TextLink } from '@origin-digital/ods-core';
import { AlertContainer } from './AlertContainer';
import { alert, interaction } from '@origin-digital/reporting-client';
import { useHistory } from 'react-router-dom';

interface BigPondAlertProps {
  analyticsTaskName: string;
  hideAlert: () => void;
}

export const BigPondAlert: React.FC<BigPondAlertProps> = ({ analyticsTaskName, hideAlert }) => {
  const history = useHistory();
  useEffect(() => {
    alert.base('notification', {
      alertMessage: 'Attention BIGPOND user',
      alertCode: `${analyticsTaskName}:bigpond-user`,
    });
  }, []);

  const onTryLinkedMobileClicked = (event) => {
    event.preventDefault();
    interaction('click', {
      componentType: 'link',
      id: 'try-linked-mobile-number',
      parentContainer: 'onetimecode-form',
      appName: analyticsTaskName,
      label: 'try using your linked mobile number',
    });
    history.goBack();
  };

  return (
    <AlertContainer data-id="alert-big-pond" onCloseClick={hideAlert} tone="info">
      <Text data-id="alert-info-text">
        <MarkdownLite>
          Some customers are experiencing delays in receiving their one-time code. We've checked it
          out, the issue seems to be with **BigPond**, your email provider. Should you have any
          problems,
        </MarkdownLite>{' '}
        <TextLink data-id="try-linked-mobile-number" href="#" onClick={onTryLinkedMobileClicked}>
          try using your linked mobile number
        </TextLink>{' '}
        to get your code.
      </Text>
    </AlertContainer>
  );
};
